const SMP = 'SMP';

export const encodeWindowName = (platformType, iframeCode) =>
    `${SMP}(${JSON.stringify(platformType)},${JSON.stringify(iframeCode)})`;

export const decodeWindowName = (windowName, callback, rollback) => {
    if (windowName.indexOf(`${SMP}(`) === 0) {
        try {
            const f = new Function(SMP, `return ${windowName}`);
            return f(callback);
        } catch (e) {
            console.error(e);
            return rollback(e, windowName, callback);
        }
    } else {
        return rollback(undefined, windowName, callback);
    }
};

export default {
    encodeWindowName,
    decodeWindowName
};
